module.exports = __webpack_public_path__ + "cc8d0c0ede502d0fe300f4cfa461b5a8.jpg";